 
/**
 * Loads carrier and location data for phone numbers in a table.
 *
 * This function dynamically adds "Carrier" and "Location" columns to the table
 * It fetches carrier and location information for each phone number row in the
 * table and populates the corresponding cells.
 * The function also manages the visibility of a loading spinner and the table
 * container based on the completion of data fetching for all rows.
 *
 */
export function loadCarrierAndLocation() {
  const phoneRows = document.querySelectorAll(
    "#phoneNumbersTableContainer tbody tr",
  );
  const loadingSpinner = document.getElementById("loadingSpinner");
  const tableContainer = document.getElementById("phoneNumbersTableContainer");
  const viewMoreContainer = document.getElementById("viewMoreContainer");
  const tableHeadRow = document.querySelector(
    "#phoneNumbersTableContainer thead tr",
  );

  let completedRequests = 0;
  const totalRows = phoneRows.length;

  if (tableHeadRow) {
    if (!document.querySelector(".carrier-header")) {
      const carrierHeader = document.createElement("th");
      carrierHeader.textContent = "Carrier";
      carrierHeader.classList.add("d-none", "d-md-table-cell", "carrier-header");
      tableHeadRow.insertBefore(carrierHeader, tableHeadRow.children[1]);
    }

    if (!document.querySelector(".location-header")) {
      const locationHeader = document.createElement("th");
      locationHeader.textContent = "Location";
      locationHeader.classList.add(
        "d-none",
        "d-md-table-cell",
        "location-header",
      );
      tableHeadRow.insertBefore(locationHeader, tableHeadRow.children[2]);
    }
  } else {
    console.warn("Table header row not found");
  }

  if (totalRows === 0) {
    if (loadingSpinner) loadingSpinner.classList.add("hidden-content");
    if (tableContainer) {
      tableContainer.classList.remove("hidden-content");
      tableContainer.classList.add("visible-content");
    }
    return;
  }
  
  phoneRows.forEach((row) => {
    const phoneNumber = row.getAttribute("data-phone");

    fetch(`/phone/api/carrier-location/${phoneNumber}/`)
      .then((response) => response.json())
      .then((data) => {
        let carrierCell = row.querySelector(".carrier-cell");
        if (!carrierCell) {
          carrierCell = document.createElement("td");
          carrierCell.classList.add(
            "carrier-cell",
            "d-none",
            "d-md-table-cell",
          );
          if (row.children.length > 0) {
            row.insertBefore(carrierCell, row.children[1]); // Insert after phone number
          } else {
            row.appendChild(carrierCell);
          }
        }
        carrierCell.textContent = data.carrier || "Unknown";

        let locationCell = row.querySelector(".location-cell");
        if (!locationCell) {
          locationCell = document.createElement("td");
          locationCell.classList.add(
            "location-cell",
            "d-none",
            "d-md-table-cell",
          );
          if (row.children.length > 1) {
            row.insertBefore(locationCell, row.children[2]); // Insert after carrier
          } else {
            row.appendChild(locationCell);
          }
        }
        const fullLocation =
          data.location && data.state
            ? `${data.location}, ${data.state}`
            : data.location || data.state || "N/A";
        locationCell.textContent = fullLocation;
      })
      .catch((error) => {
        console.error("Error fetching carrier/location:", error);
      })
      .finally(() => {
        completedRequests++;

        if (completedRequests === totalRows) {
          if (loadingSpinner) loadingSpinner.classList.add("hidden-content"); // Hide spinner
          if (tableContainer) {
            tableContainer.classList.remove("hidden-content");
            tableContainer.classList.add("visible-content");
          }
          if (viewMoreContainer) {
            viewMoreContainer.classList.remove("hidden-content");
            viewMoreContainer.classList.add("visible-content");
          }
        }
      });
  });
}

/**
 * Enables "View More" and "View Less" functionality for a table with hidden rows.
 *
 * This function hides extra rows in a table by default and provides buttons to
 * toggle their visibility. It also ensures smooth scrolling to the table header
 * when collapsing rows.
 */
export function enableViewMoreFunctionality() {
  const viewMoreBtn = document.getElementById("viewMoreBtn");
  const viewLessBtn = document.getElementById("viewLessBtn");
  const hiddenRows = document.querySelectorAll(".hidden-row");

  if (!viewMoreBtn || !viewLessBtn) return;

  hiddenRows.forEach((row) => {
    row.style.display = "none";
  });

  if (hiddenRows.length > 0) {
    viewMoreBtn.style.display = "inline-block";
  } else {
    viewMoreBtn.style.display = "none";
  }

  viewMoreBtn.addEventListener("click", () => {
    hiddenRows.forEach((row) => {
      row.style.display = "table-row";
    });
    viewMoreBtn.style.display = "none";
    viewLessBtn.style.display = "inline-block";
  });

  viewLessBtn.addEventListener("click", () => {
    hiddenRows.forEach((row) => {
      row.style.display = "none";
    });
    viewMoreBtn.style.display = "inline-block";
    viewLessBtn.style.display = "none";

    const tableHeader = document.getElementById("phoneNumbersTableHeader");
    if (tableHeader) {
      tableHeader.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });
}
